import { fontFamily, BorderRadius, Spacing } from '@doordash/design-language'
import styled from 'styled-components'

// This is an object over a styled component object
// due to this styling being passed to vgs form field
export const ssnFieldStyles = {
  boxSizing: 'border-box',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: 1.5,
  padding: `${Spacing.XxSmall}px ${Spacing.Small}px`,
  borderRadius: BorderRadius.FieldsInputDefault,
  boxShadow: 'rgb(214, 214, 214) 0px 0px 0px 1px inset',
  height: '40px',
  width: '100%',
  color: 'rgb(25, 25, 25)',
  fontFamily,
}

export const SsnField = styled.div`
  width: 100%;
  iframe {
    width: 100%;
    height: 40px;
  }
`

export const SsnLabel = styled.label`
  font-size: 14px;
  font-family: ${fontFamily};
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0ch;
  text-transform: none;
`

export const SsnDescription = styled.div`
  font-size: 14px;
  font-family: ${fontFamily};
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0ch;
  text-transform: none;
  text-align: right;
`

export const SsnLabelWrapper = styled.div`
  margin-bottom: ${Spacing.XxxSmall}px;
  display: flex;
  justify-content: space-between;
`

type HiddenProps = {
  isHidden: boolean
}
export const Hider = styled.div`
  display: ${({ isHidden }: HiddenProps) => (isHidden ? 'none' : 'block')};
`
